import ErrorString from './error_string';

export default function Text(props)
{
    const {
        className,
        error,
        id,
        maxLength,
        name,
        onChange,
        placeholder,
        required,
        value
    } = props

    return (
        <>
            <input
                id={ id }
                name={ name }
                value={ value }
                className={ "block w-full bg-white border-grey-2 rounded-sm focus:border-bb focus:ring-bb" + (className ? " " + className : "") }
                placeholder={ placeholder }
                maxLength={ maxLength }
                required={ required }
                type="text"
                onChange={ onChange }
            />
            <ErrorString error={ error } />
        </>
    );
}